import { ISameCaseMatchedCasesSearchModel, SameCaseSortColumns } from '../../../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';

import { ISameCaseModel } from '../../../../interfaces/ISameCaseModel';
import { SortableHeader } from '../../../shared/SortableHeader';
import { Table } from 'react-bootstrap';

export default function SameCasesTable(props: {
    currentFilters: ISameCaseMatchedCasesSearchModel;
    onSelectedSameCase?: (caseGroup: ISameCaseModel) => void;
    onSort: (key: string, order: string, subKey?: string) => void;
    results: ISameCaseModel[];
    selectedCaseGroup?: ISameCaseModel;
}) {
    const handleRowSelected = (caseGroup: ISameCaseModel) => {
        props.onSelectedSameCase?.(caseGroup);
    };

    return (
        <Table size="sm">
            <thead>
                <tr>
                    <th style={{ width: 30 }} />
                    <SortableHeader
                        active={
                            props.currentFilters.sortModel.sortColumn ===
                            SameCaseSortColumns.CaseNumber
                        }
                        currentSortModel={props.currentFilters.sortModel}
                        headerText="Case Number"
                        sortKey="caseNumber"
                        onSort={props.onSort}
                        noWrap
                        thStyle={{ width: 200 }}
                    />
                    <SortableHeader
                        active={
                            props.currentFilters.sortModel.sortColumn ===
                            SameCaseSortColumns.Jurisdiction
                        }
                        currentSortModel={props.currentFilters.sortModel}
                        headerText="Jurisdiction"
                        sortKey="jurisdiction"
                        onSort={props.onSort}
                        noWrap
                        thStyle={{ width: 200 }}
                    />
                    <SortableHeader
                        active={
                            props.currentFilters.sortModel.sortColumn ===
                            SameCaseSortColumns.CaseName
                        }
                        currentSortModel={props.currentFilters.sortModel}
                        headerText="Same Case Name"
                        sortKey="caseName"
                        onSort={props.onSort}
                        noWrap
                    />
                </tr>
            </thead>
            <tbody>
                {props.results.map((row) => (
                    <tr key={row.guid}>
                        <td>
                            <input
                                type="radio"
                                className="form-check-radio"
                                onChange={() => handleRowSelected(row)}
                                checked={
                                    !!props.selectedCaseGroup?.guid &&
                                    row.guid === props.selectedCaseGroup.guid
                                }
                                value={row.guid ?? ''}
                            />
                        </td>
                        <td>{row.caseNumber}</td>
                        <td>{row.jurisdiction}</td>
                        <td>{row.caseName}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}
